<template>
  <VueApexCharts v-if="ready" v-bind="$attrs" />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, onMounted, ref } from 'vue'
import { loadApexCharts } from '@/composables/useApexChartsLoader'

const VueApexCharts = defineAsyncComponent(() => loadApexCharts())

export default defineComponent({
  name: 'ApexChartSafe',
  components: { VueApexCharts },
  inheritAttrs: false,
  setup() {
    const ready = ref(false)

    onMounted(() => {
      ready.value = true
    })

    return { ready }
  },
})
</script>
